import { useMemo } from 'react';

import { useUserSessionRegions } from 'dibs-regional-info/exports/regionalInfoHelpers';

export const useUserShippingRegionsUrlLabels = (): string[] => {
    const userRegions = useUserSessionRegions();
    return useMemo(() => userRegions?.map(region => region.urlLabel) || [], [userRegions]);
};
